import { IonCheckbox, IonIcon } from '@ionic/react';
import { informationCircleOutline } from 'ionicons/icons';
import { ChannelImage } from '../channels/components/ChannelImage';
import { officialChannelsFollowMessage } from './officialChannelsFollowMessage';

export interface OfficialChannel {
  id: string;
  name: string;
  image?: string | null;
  updatedAt?: string | null;
}

interface OfficialChannelsFollowBlockProps {
  /** Whether the user is creating or joining the league: it changes the wording. */
  action: 'create' | 'join';
  channels: OfficialChannel[];
  selectedChannelIds: string[];
  onSelectedChannelIdsChange: (channelIds: string[]) => void;
}

/**
 * Informs that creating or joining a league makes the user follow the official
 * channels of its competition, with one checkbox per channel (checked by default).
 */
export const OfficialChannelsFollowBlock = ({
  action,
  channels,
  selectedChannelIds,
  onSelectedChannelIdsChange,
}: OfficialChannelsFollowBlockProps) => {
  const handleCheckedChange = (channelId: string, checked: boolean) => {
    if (checked) {
      onSelectedChannelIdsChange([...new Set([...selectedChannelIds, channelId])]);
    } else {
      onSelectedChannelIdsChange(selectedChannelIds.filter((id) => id !== channelId));
    }
  };

  return (
    <section
      className="rounded-lg border border-blue-200 bg-blue-50 p-4"
      aria-label="Canales oficiales de la competición"
    >
      <div className="flex items-start gap-2">
        <IonIcon
          icon={informationCircleOutline}
          className="mt-0.5 shrink-0 text-blue-600"
          aria-hidden="true"
        />
        <div className="min-w-0 flex-1">
          <p className="text-xs leading-snug text-slate-600">
            {officialChannelsFollowMessage(action, channels.length)}
          </p>

          <ul className="mt-3 space-y-2">
            {channels.map((channel) => (
              <li key={channel.id} className="flex items-center gap-3">
                <IonCheckbox
                  checked={selectedChannelIds.includes(channel.id)}
                  onIonChange={(e) => handleCheckedChange(channel.id, e.detail.checked)}
                  aria-label={`Seguir ${channel.name}`}
                />
                <ChannelImage
                  image={channel.image}
                  updatedAt={channel.updatedAt}
                  name={channel.name}
                  size={28}
                />
                <span className="truncate text-sm font-medium text-slate-900">{channel.name}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
